import React, { useEffect, useRef, useState } from 'react';
import styled from 'styled-components';
import { SourceFreshnessRunStatus } from '../../../types';
import { formatTimeValue } from '../../../utils/datetime';
import { Flex } from '../../Flex';
import AnomalyChartTooltip from '../AnomalyChartTooltip';
import { statusColorMap } from '../FreshnessChartCommon';
import { TooltipData } from './types';

type Props = {
  data: TooltipData | null;
  x: number;
  y: number;
  status: SourceFreshnessRunStatus;
  limits: {
    left: number;
    right: number;
  };
  loading?: boolean;
};

const ChartTooltip = styled(Flex)<{
  $left: number;
  $top: number;
  $hidden: boolean;
}>`
  height: fit-content;
  position: fixed;
  ${({ $hidden }) => ($hidden ? 'visibility: hidden;' : '')}
  left: ${({ $left }) => $left}px;
  top: ${({ $top }) => $top}px;
  z-index: 3;
  transform: translateX(-50%) translateY(-105%);
  width: 305px;
  pointer-events: none;
`;

const AutoFreshnessChartTooltip = ({
  data,
  x,
  y,
  status,
  limits,
  loading = false,
}: Props) => {
  const ref = useRef<HTMLDivElement>(null);
  const [safeX, setSafeX] = useState(x);

  useEffect(() => {
    if (ref.current) {
      const rect = ref.current.getBoundingClientRect();
      const maxX = limits.right - rect.width / 2;
      const minX = limits.left + rect.width / 2;
      setSafeX(Math.min(Math.max(x, minX), maxX));
    }
  }, [x, limits]);
  return (
    <ChartTooltip ref={ref} $left={safeX} $top={y} $hidden={!data || loading}>
      <AnomalyChartTooltip
        active
        data={data?.payload}
        metricsTitle="Time without updates"
        valueColor={data?.valueColor}
        rangeColor={statusColorMap.learn}
        status={status}
        valueFormatter={formatTimeValue}
        shouldExpectDataRange={false} // Freshness has a single detection point, so no range is expected for other points
      />
    </ChartTooltip>
  );
};

export default React.memo(AutoFreshnessChartTooltip);
